





































































import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import dayjs from 'dayjs';
import { AxiosError } from 'axios';

import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import { DateRange } from '@/components/DatePicker.vue';

import api from '@/libs/api';
import format from '@/libs/numberFormat';
import { MerchantChangeResponse, MerchantChange } from '@/libs/api.interfaces';

interface ReportParams {
  merchant_code: SelectItem[];
  api_usage: SelectItem[];
  revenue: SelectItem[];
  service_fee: SelectItem[];
  gross_fee: SelectItem[];
  date: DateRange;
}

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    ActionPopup,
  },
  methods: {
    format,
  },
})
export default class ReportTable extends Vue {
  channel = { title: '', code: '', path: '' };

  loading = true;
  history: MerchantChange[] = [];

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  format!: (val: string) => string;
  // eslint-disable-next-line class-methods-use-this
  openDetail(clientId: number, date: string) {
    // eslint-disable-next-line @typescript-eslint/camelcase
    window.open(`/auto-disbursement-management/bank-service/merchant-charge/${clientId}/${date}`, '_blank');
  }

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString() },
    });
  }

  async getTransaction(params: ReportParams, page = 1) {
    this.loading = true;
    try {
      const date = {
        startDate: params.date.startDate === null ? undefined
          : dayjs(params.date.startDate).hour(0).minute(0).second(0)
            .format('YYYY-MM-DD HH:mm:ss'),
        endDate: params.date.endDate === null ? undefined
          : dayjs(params.date.endDate).hour(23).minute(59).second(59)
            .format('YYYY-MM-DD HH:mm:ss'),
      };
      console.log(params);
      // const merchant_code = params.merchant_code ? undefined : params.merchant_code;
      // eslint-disable-next-line @typescript-eslint/camelcase
      const merchant_code = params.merchant_code.length === 0 ? undefined
        : params.merchant_code.map((e) => e.value);
      // eslint-disable-next-line @typescript-eslint/camelcase
      const api_usage = params.api_usage.length === 0 ? undefined
        : params.api_usage.map((e) => e.value);
      // const api_usage = params.api_usage.value ? undefined : params.api_usage.value;
      const revenue = params.revenue.length === 0 ? undefined
        : params.revenue.map((e) => e.value);
      // eslint-disable-next-line @typescript-eslint/camelcase
      // const revenue = params.revenue ? undefined : params.revenue;
      // eslint-disable-next-line @typescript-eslint/camelcase
      const service_fee = params.service_fee.length === 0 ? undefined
        : params.service_fee.map((e) => e.value);
      // eslint-disable-next-line @typescript-eslint/camelcase
      const gross_fee = params.gross_fee.length === 0 ? undefined
        : params.service_fee.map((e) => e.value);
      // const service_fee = params.service_fee ? undefined : params.service_fee;

      const { data } = await api.get<MerchantChangeResponse>('/disbursement/summary-api/index', {
        params: {
          page,
          // eslint-disable-next-line @typescript-eslint/camelcase
          start_date: date.startDate,
          // eslint-disable-next-line @typescript-eslint/camelcase
          end_date: date.endDate,
          // eslint-disable-next-line @typescript-eslint/camelcase
          merchant_code,
          // eslint-disable-next-line @typescript-eslint/camelcase
          api_usage,
          // eslint-disable-next-line @typescript-eslint/camelcase
          revenue,
          // eslint-disable-next-line @typescript-eslint/camelcase
          service_fee,
          // eslint-disable-next-line @typescript-eslint/camelcase
          gross_fee,
        },
      });

      this.page = page;
      this.history = data.data;
      this.totalPage = Math.ceil(data.total / data.per_page);
      this.from = data.from;
      this.to = data.to;
      this.totalItem = data.total;
      this.loading = false;

      return null;
    } catch (err) {
      console.error(err);
      return err as AxiosError;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    const formatted = dayjs(time).format('MMMM D, YYYY');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }
}
